 

export const reports = {
  state: {
    notificationsChange: false,
    hasToUpdateNewMessages: false,
    lastPayload: null,
    newMessages: []
  },
  actions: {
    async notificationsChange({commit},payload){
      commit('notificationsChangeSuccess', payload)
      return payload;
    },
    async updateNewMessages({commit},payload){
      commit('updateNewMessagesSuccess', payload)
      return payload;
    },
    addNewMessage({commit},payload){
      commit('addNewMessageSuccess', payload)
      return payload;
    },
    clearNewMessagesById({commit},payload){
      commit('clearNewMessagesByIdSuccess', payload)
      return payload;
    }
  },
  getters: {
    notificationsChange: state => state.notificationsChange,
    hasToUpdateNewMessages: state => state.hasToUpdateNewMessages,
    lastPayload: state => state.lastPayload
  },
  mutations: {
    notificationsChangeSuccess(state, payload) {
      state.notificationsChange = !state.notificationsChange;
    },
    updateNewMessagesSuccess(state, payload) {
      state.lastPayload = payload;
      state.hasToUpdateNewMessages = !state.hasToUpdateNewMessages;
    },
    addNewMessageSuccess(state, payload) {
      if(!state.newMessages){
        state.newMessages = [];
      }
      state.newMessages.push(payload);
    },
    clearNewMessagesById(state, payload) {
      if(!state.newMessages){
        state.newMessages = [];
      }
      state.newMessages = _.filter(state.newMessages,(m) => m.id != payload.id);
    },
  },   
};

export default reports;
